export default {
  menu: {
    home: "首页",
    solution: "解决方案",
    contact: "联系我们",
    aboutus: "关于我们"
  }
};



// WEBPACK FOOTER //
// ./src/lang/zh/menu.js